import { lazyWithRetry as lazy } from "@/utils/lazy-with-retry";

export const AccountGallery = lazy(() => import("../../account-gallery"));
export const AccountSearch = lazy(() => import("../../account-search"));
export const AccountTimeline = lazy(() => import("../../account-timeline"));
export const AdsSettings = lazy(() => import("../../settings/ads"));
export const AiSearch = lazy(() => import("../../ai-search"));
export const AiSearchResults = lazy(() => import("../../ai-search/results"));
export const AlertAccounts = lazy(() => import("../../alerts/components/alert-accounts"));
export const AlertSettings = lazy(() => import("../../alerts/components/settings"));
export const Alerts = lazy(() => import("../../alerts"));
export const Audio = lazy(() => import("../../audio"));
export const BlocksSettings = lazy(() => import("../../settings/blocks"));
export const BoostDashboard = lazy(() => import("../../boosts/components/boost-dashboard"));
export const Bookmarks = lazy(() => import("../../bookmarks/index"));
export const ChatIndex = lazy(() => import("../../chats"));
export const ChatWidget = lazy(() => import("../../chats/components/chat-widget/chat-widget"));
export const CreateGroupModal = lazy(() => import("../components/modals/create-group-modal"));
export const CtaBanner = lazy(() => import("../components/cta-banner"));
export const DeleteAccountSettings = lazy(() => import("../../settings/delete-account"));
export const Discover = lazy(() => import("../../discover"));
export const SportsLive = lazy(() => import("../../sports/live"));
export const SportsUpcoming = lazy(() => import("../../sports/upcoming"));
export const GameDetails = lazy(() => import("../../game-details"));
export const TeamDetails = lazy(() => import("../../team-details"));
export const NewsArticleDetail = lazy(() => import("../../sports-news/sports-news-details"));
export const SportsNews = lazy(() => import("../../sports-news/sports-news-list"));
export const DiscoverabilitySettings = lazy(() => import("../../settings/discoverability"));
export const DownloadYourInformationSettings = lazy(() => import("../../settings/download-your-info"));
export const EditFeed = lazy(() => import("../../feed/edit-feed"));
export const EmojiPicker = lazy(() => import("../../emoji/components/emoji-picker"));
export const ExternalLogin = lazy(() => import("../../external-login"));
export const FavouritedStatuses = lazy(() => import("../../favourited-statuses"));
export const Feeds = lazy(() => import("../../feeds"));
export const GemsLeaderboard = lazy(() => import("../../gems/leaderboard"));
export const GenericNotFound = lazy(() => import("../../generic-not-found"));
export const GroupAbout = lazy(() => import("../../group/group-about"));
export const GroupEvents = lazy(() => import("../../group/group-events"));
export const GroupGallery = lazy(() => import("../../group/group-gallery"));
export const GroupMediaPanel = lazy(() => import("../components/group-media-panel"));
export const GroupSearch = lazy(() => import("../../group/group-search"));
export const GroupTagTimeline = lazy(() => import("../../group/group-tag-timeline"));
export const GroupTags = lazy(() => import("../../group/group-tags"));
export const GroupTimeline = lazy(() => import("../../group/group-timeline"));
export const Groups = lazy(() => import("../../groups"));
export const GroupsCategory = lazy(() => import("../../groups/category"));
export const GroupsDiscover = lazy(() => import("../../groups/discover"));
export const GroupsSuggested = lazy(() => import("../../groups/suggested"));
export const GroupsTag = lazy(() => import("../../groups/tag"));
export const HashtagTimeline = lazy(() => import("../../hashtag-timeline"));
export const HomeTimeline = lazy(() => import("../../home-timeline"));
export const LiveTvPanel = lazy(() => import("../components/panels/live-tv-panel"));
export const LiveVideoPlayer = lazy(() => import("../../../components/video/live-video-player"));
export const LogoutPage = lazy(() => import("../../auth-login/components/logout"));
export const ManageGroupModal = lazy(() => import("../components/modals/manage-group-modal"));
export const MediaGallery = lazy(() => import("../../../components/media-gallery"));
export const MessagesSettings = lazy(() => import("../../settings/messages"));
export const MfaSettings = lazy(() => import("../../settings/mfa"));
export const MuteSettings = lazy(() => import("../../settings/mutes"));
export const MyGroupsPanel = lazy(() => import("../components/panels/my-groups-panel"));
export const NewGroupPanel = lazy(() => import("../components/panels/new-group-panel"));
export const NewStatus = lazy(() => import("../../new-status"));
export const OnboardingModal = lazy(() => import("../components/modals/onboarding-modal/onboarding-modal"));
export const OtherSettings = lazy(() => import("../../settings/other"));
export const PasswordResetConfirm = lazy(() => import("../../auth-login/components/password-reset-confirm"));
export const PasswordSettings = lazy(() => import("../../settings/password"));
export const PendingGroupRequests = lazy(() => import("../../groups/pending-requests"));
export const PredictionDetail = lazy(() => import("../../predictions/prediction-detail"));
export const Predictions = lazy(() => import("../../predictions"));
export const PreferencesSettings = lazy(() => import("../../settings/preferences"));
export const PrivacySettings = lazy(() => import("../../settings/privacy"));
export const ProfileInfoPanel = lazy(() => import("../components/profile-info-panel"));
export const ProfileMediaPanel = lazy(() => import("../components/profile-media-panel"));
export const ProfileSettings = lazy(() => import("../../settings/profile"));
export const Search = lazy(() => import("../../search"));
export const SecuritySettings = lazy(() => import("../../settings/security"));
export const ServerInfo = lazy(() => import("../../server-info"));
export const SessionsSettings = lazy(() => import("../../settings/sessions"));
export const Settings = lazy(() => import("../../settings"));
export const Share = lazy(() => import("../../share"));
export const SidebarMenu = lazy(() => import("../../../components/sidebar/sidebar-menu"));
export const SignUpPanel = lazy(() => import("../components/panels/sign-up-panel"));
export const Status = lazy(() => import("../../status"));
export const StatusHistory = lazy(() => import("../../status-history"));
export const StatusVideoPlayer = lazy(() => import("../../../components/statuses/status-video-player"));
export const SubscriptionPayments = lazy(() => import("../../settings/subscription-payments"));
export const SubscriptionSettings = lazy(() => import("../../settings/subscriptions"));
export const SuggestedGroupsPanel = lazy(() => import("../components/panels/suggested-groups-panel"));
export const TrendingEventsPanel = lazy(() => import("../components/panels/trending-events-panel"));
export const TrendsPanel = lazy(() => import("../components/panels/trends-panel"));
export const TruthPlusPanel = lazy(() => import("../components/panels/truth-plus-panel"));
export const UserPanel = lazy(() => import("../components/user-panel"));
export const VerifySmsModal = lazy(() => import("../components/modals/verify-sms-modal"));
